import { send } from "./slsCore";
import qs from "query-string";
import Cookies from "js-cookie";

/**
 * 自定义埋点
 */
export interface IWebSlsInfoModel extends Record<string, any> {
  key: string; // 埋点key
}

export const webSlsDownloadLogger = (
  key: string,
  p?: Record<string, string>
) => {
  const {
    open = "",
    type = "",
    utm_source = "",
    utm_medium = "",
    utm_campaign = "",
    utm_term = "",
    utm_content = "",
  } = qs.parse(location.search);
  const options: IWebSlsInfoModel = {
    key,
    channel: utm_source,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
    open_type: open,
    theme: type,
    uid: Cookies.get("_gid") || "",
    ...(p || {}),
  };
  console.log("[webSlsShareLogger]", key, options);
  send(options);
};
